import { useState, useMemo } from "react";
import { CREDIT_META, ROLE_DATA } from "./data";
import CreditBadge from "./CreditBadge";
import styles from "./pricing.module.css";

export default function RolesTab() {
  const [search, setSearch] = useState("");
  const [activeCategory, setActiveCategory] = useState("all");
  const [showFuture, setShowFuture] = useState(false);

  const filtered = useMemo(() => {
    const q = search.toLowerCase();
    return ROLE_DATA.map((cat) => ({
      ...cat,
      subcategories: cat.subcategories
        .map((sub) => ({
          ...sub,
          roles: sub.roles.filter((r) => {
            if (!showFuture && r.future) return false;
            if (activeCategory !== "all" && cat.category !== activeCategory)
              return false;
            if (
              q &&
              !r.title.toLowerCase().includes(q) &&
              !sub.name.toLowerCase().includes(q) &&
              !cat.category.toLowerCase().includes(q)
            )
              return false;
            return true;
          }),
        }))
        .filter((s) => s.roles.length > 0),
    })).filter(
      (cat) =>
        (activeCategory === "all" || cat.category === activeCategory) &&
        cat.subcategories.length > 0,
    );
  }, [search, activeCategory, showFuture]);

  return (
    <div>
      {/* Credit legend */}
      <div className={styles.rolesLegend}>
        {Object.entries(CREDIT_META).map(([level, meta]) => (
          <div
            key={level}
            className={`${styles.rolesLegendChip} ${styles["creditLevel" + level]}`}
          >
            <span
              className={`${styles.rolesLegendDot} ${styles["creditSolid" + level]}`}
            />
            <span
              className={`${styles.rolesLegendText} ${styles["creditText" + level]}`}
            >
              {level}C{" "}
              <span className={styles.rolesLegendTextMuted}>
                · {meta.label}
              </span>
            </span>
          </div>
        ))}
      </div>

      {/* Controls */}
      <div className={styles.rolesControls}>
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search roles..."
          className={styles.rolesSearchInput}
        />
        <div className={styles.rolesCategoryRow}>
          {["all", ...ROLE_DATA.map((c) => c.category)].map((cat) => {
            const d = ROLE_DATA.find((c) => c.category === cat);
            const label =
              cat === "all"
                ? "All"
                : d
                  ? `${d.icon} ${cat.split(" ")[0]}`
                  : cat;
            return (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`${styles.rolesCategoryBtn} ${activeCategory === cat ? styles.rolesCategoryBtnActive : ""}`}
              >
                {label}
              </button>
            );
          })}
        </div>
        {/* <label className={styles.rolesFutureToggle}>
          <input
            type="checkbox"
            checked={showFuture}
            onChange={(e) => setShowFuture(e.target.checked)}
          />
          Show upcoming
        </label> */}
      </div>

      {filtered.length === 0 ? (
        <div className={styles.rolesEmpty}>No roles match your search.</div>
      ) : (
        filtered.map((cat) => (
          <div key={cat.category} className={styles.rolesCategoryBlock}>
            <div className={styles.rolesCategoryHeader}>
              <span className={styles.rolesCategoryIcon}>{cat.icon}</span>
              <h2 className={styles.rolesCategoryTitle}>{cat.category}</h2>
            </div>
            <div className={styles.rolesSubGrid}>
              {cat.subcategories.map((sub) => (
                <div key={sub.name} className={styles.rolesSubCard}>
                  <div className={styles.rolesSubName}>{sub.name}</div>
                  <div className={styles.rolesRoleList}>
                    {sub.roles.map((role) => (
                      <div key={role.title} className={styles.rolesRoleRow}>
                        <div className={styles.rolesRoleLeft}>
                          <span
                            className={`${styles.rolesRoleTitle} ${role.future ? styles.rolesRoleTitleFuture : ""}`}
                          >
                            {role.title}
                          </span>
                          {role.future && (
                            <span className={styles.rolesSoonBadge}>soon</span>
                          )}
                        </div>
                        <CreditBadge credits={role.credits} />
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))
      )}
    </div>
  );
}
